import { API, Competition, CompetitionAPI, PageModel } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export interface getListProps {
  i18n: any
  competitionIds?: string[] 
  competitionStatus?: number[]
  initTags?: boolean;
  limit?: number
  page?: number
  contexts?: string[];
  initWinner?: boolean;
  isBriefCompetition?: boolean;
};

export const fetchCompetitionProjects = createAsyncThunk(
  'competitions/fetchCompetitionProjects',
  async (args: any) => {
    const { i18n, initTags, limit = 100, page = 0, contexts, initWinner = false, isBriefCompetition } = args;

    const json = await API.Json(
      CompetitionAPI.GetList(
        { 
          initTags, 
          limit, 
          page, 
          contexts,
          isBriefCompetition,  
          initWinner, 
        } as any))

    return {
      data: API.toLang<PageModel<Competition>>(json, i18n.language),
      contexts
    }
  }
);

export const getList = (props: getListProps) => {
  const { i18n, limit = 100, page = 0, ...rest } = props
  return CompetitionAPI.GetList({ limit, page, ...rest } as any)
    .then((value) => value.json())
    .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
};

export const competitionService = {
  getList
};import { API, Competition, CompetitionAPI, PageModel } from '@brg/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export interface getListProps {
  i18n: any
  competitionIds?: string[] 
  competitionStatus?: number[]
  initTags?: boolean;
  limit?: number
  page?: number
  contexts?: string[];
  initWinner?: boolean;
  isBriefCompetition?: boolean;
};

export const fetchCompetitionProjects = createAsyncThunk(
  'competitions/fetchCompetitionProjects',
  async (args: any) => {
    const { i18n, initTags, limit = 100, page = 0, contexts, initWinner = false, isBriefCompetition } = args;

    const json = await API.Json(
      CompetitionAPI.GetList(
        { 
          initTags, 
          limit, 
          page, 
          contexts,
          isBriefCompetition,  
          initWinner, 
        } as any))

    return {
      data: API.toLang<PageModel<Competition>>(json, i18n.language),
      contexts
    }
  }
);

export const getList = (props: getListProps) => {
  const { i18n, limit = 100, page = 0, ...rest } = props
  return CompetitionAPI.GetList({ limit, page, ...rest } as any)
    .then((value) => value.json())
    .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
};

export const competitionService = {
  getList
};